import { render } from "./application.vue?vue&type=template&id=a533ab74&scoped=true&ts=true"
import script from "./application.vue?vue&type=script&lang=ts"
export * from "./application.vue?vue&type=script&lang=ts"

import "./application.vue?vue&type=style&index=0&id=a533ab74&lang=less&rel=stylesheet%2Fless&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a533ab74"]])

export default __exports__